
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inscription-pro",
      function () {
        return require("private-next-pages/inscription-pro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inscription-pro"])
      });
    }
  